import { PluginInitializerService } from 'core-client/api'
import { StreamingService } from './streaming.service';

export function streamingInitializerFactory(streamingService: StreamingService, configService: PluginInitializerService): () => Promise<void> {
    return () =>
        new Promise<void>((resolve) => {
            const init = async () => {
                await streamingService.setup();
            };

            configService.setup('streaming', init, resolve);
        });
}
